import React, { useCallback, useState }  from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

// SemanticUI components
import { Form, FormGroup, FormInput, FormSelect, Grid, GridRow, GridColumn, Header, HeaderContent, Icon, Card, CardContent, CardGroup, Label, Button, Container, Modal, Segment } from 'semantic-ui-react';

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { setContractData, resetObject, setContractIsLoaded, abortEdit, hideSidebar } from './contractSlice';
import { setActivePage, setUser, setToken, setContractId } from '../../appSlice';

// SystemData
import { mapSeasonsToOptions } from '../contract/systemdata';
import { map3lcToOptions } from '../contract/systemdata';
import { mapHotelchainToOptions } from '../contract/systemdata';
import { mapAgencyToOptions } from '../contract/systemdata';
import { mapCategoryToOptions } from '../contract/systemdata';
import { mapCategoryTOToOptions } from '../contract/systemdata';
import { mapHoteltypeToOptions } from '../contract/systemdata';



/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Styles
import './contract.css';


registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractBasicdata = ({editMode}) => {
  // local state
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [contracts, setContracts] = useState([]);

  //global State
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const contractData  = useSelector((state) => state.contract.data.Contract);
  const contractId    = useSelector((state) => state.app.contractId);
  const objectID      = useSelector((state) => state.app.objectId);
  const systemData    = useSelector((state) => state.app.systemData);
  
  // i18n
  const { t } = useTranslation();
  
  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  // Edit mode?
  const readOnly = editMode ? false : true;

  // Systemdaten
  const derivedOptionsSeason = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_saison']) return [];
    const rawData = systemData['icmp006.system_saison'] ?? [];
    return mapSeasonsToOptions(rawData);
  }, [systemData]);

  const derivedOptions3lc = React.useMemo(() => {
    if (!systemData || !systemData['icmp_zgbs']) return [];
    const rawData = systemData['icmp_zgbs'] ?? [];
    return map3lcToOptions(rawData);
  }, [systemData]);

  const derivedOptionsHotelchain = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_hotelkette']) return [];
    const rawData = systemData['icmp006.system_hotelkette'] ?? [];
    return mapHotelchainToOptions(rawData);
  }, [systemData]);

  const derivedOptionsAgency = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_agentur']) return [];
    const rawData = systemData['icmp006.system_agentur'] ?? [];
    return mapAgencyToOptions(rawData);
  }, [systemData]);

  const derivedOptionsCategory = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_kategorie_blank']) return [];
    const rawData = systemData['icmp006.system_kategorie_blank'] ?? [];
    return mapCategoryToOptions(rawData);
  }, [systemData]);

  const derivedOptionsCategoryTO = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_kategorie']) return [];
    const rawData = systemData['icmp006.system_kategorie'] ?? [];
    return mapCategoryTOToOptions(rawData);
  }, [systemData]);

  const derivedOptionsHoteltype = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_hoteltyp']) return [];
    const rawData = systemData['icmp006.system_hoteltyp'] ?? [];
    return mapHoteltypeToOptions(rawData);
  }, [systemData]);



  /**
   * Get filtered hotelcodes from server
   * 
   * @param {String} query 
   * @param {String} url 
   *
  const fetchOptions = async (query, url) => {
    setIsLoading(true);
    
    try {
      const api = new AjaxController(url, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });
      const hotelcodes = await api.get('/hotelcodes/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

      setOptions(hotelcodes);
    } catch (error) {
      console.error("Fehler beim Laden der Optionen:", error);
    }

    setIsLoading(false);
  };



  /**
   * Handle input change in Dropdown
   * 
   * @param {Event} e 
   * @param {String} searchQuery 
   *
  const handleSearchChange = (e, { searchQuery }) => {
    setSearchQuery(searchQuery);

    // Load options after 3 or more characters
    if (searchQuery.length >= 3) {
      fetchOptions(searchQuery, backendUrl);
    } else {
      setOptions([]);
    }
  };
  /**/




  const openSearchModalClick = useCallback(async (hotelcode) => {
    if (!hotelcode) {
      enqueueSnackbar(t('contract.basicdata.errors.noHotelcodeFilter'), { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar(t('common.backendUrlUndefined'), { variant: 'error' });
      return;
    }

    // openModal
    setShowSearchModal(true)

    // show loading animation
    setIsLoading(true);

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // send create pdf request
    let response;
    try {
      response = await api.get('/hotel/' + objectID + '/contracts');
      if (typeof response !== 'undefined' && typeof response.Contracts !== 'undefined') {
        let _contracts = [];
        response?.Contracts.forEach(record => {
          let found = false;
          contractData.Links.SubContracts.forEach(link => {
            if (link.id === record.ContractId) {
              found = true;
            }
          });
          if (record.ContractId !== contractId && contractData.Basics.Season.value === record.SeasonId && !found) {
            _contracts.push(record);
          }
        });
        setIsLoading(false);
        setContracts(_contracts);
        return;
      }
    } catch (error) {
      enqueueSnackbar(t('contract.basicdata.errors.filterAgencyCode'), { variant: 'error' });
      setIsLoading(false);
      return;
    }
    
    //
    setIsLoading(false);
  }, [backendUrl, contractId, objectID, contractData, dispatch, enqueueSnackbar, t]);



  const handleOpenContractClick = (cid) => {
    dispatch(hideSidebar());
    dispatch(abortEdit());
    dispatch(resetObject());
    dispatch(setContractIsLoaded(false));
    dispatch(setContractId(cid));
  }



  const linkContractClick = (contract) => {
    const link = {
      id: contract.ContractId, 
      text: '',
      STATUS: contract.Meta.Status,
      Basics: {
          Hotelcode: contract.Hotelcode,
          Hotelname: contract.Hotelname,
          Season: {
              key: contract.SeasonId, 
              value: contract.SeasonId, 
              text: contract.SeasonName, 
          }
        }
    }
    dispatch(setContractData({target: 'Link.Sub', value: link}))

    closeSearchModalClick();
  }



  const unlinkContractClick = (link) => {
    console.log('[link]', link)
    dispatch(setContractData({target: 'Unlink.Sub', value: link.id}))

    closeSearchModalClick();
  }




  const closeSearchModalClick = () => {
    setContracts([]);
    setShowSearchModal(false);
  }




  if (readOnly) {
    return (
      <>
      <Grid>
        <GridRow columns={2}>
          <GridColumn width={6}>
            <Header as='h4'>{t('contract.basicdata.section.mainHeader')}</Header>
            <br />
            <Grid>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.seasonRange')}</GridColumn><GridColumn width={11}>{contractData.Basics.Season.text}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.destinationAirport')}</GridColumn><GridColumn width={11}>{contractData.Basics.Destination}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.hotelChain')}</GridColumn><GridColumn width={11}>{contractData.Basics.HotelChain}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.hotelName')}</GridColumn><GridColumn width={11}>{contractData.Basics.Hotelname}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.agencyCode')}</GridColumn><GridColumn width={11}>{contractData.Basics.AgencyCode}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.toNumber')}</GridColumn><GridColumn width={11}>{contractData.Basics.TONumber}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.touristicService')}</GridColumn><GridColumn width={11}>{contractData.Basics.TLeistung}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.categoryOff')}</GridColumn><GridColumn width={11}>{contractData.Basics.CategoryOff}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.categoryInt')}</GridColumn><GridColumn width={11}>{contractData.Basics.CategoryInt}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.hotelType')}</GridColumn><GridColumn width={11}>{contractData.Basics.HotelType}</GridColumn></GridRow>
            </Grid>
          </GridColumn>


          <GridColumn width={5}>
            <Header as='h4'>{t('contract.basicdata.section.address')}</Header>
            <br />
            <Grid>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.street')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Street}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.postcode')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Postcode}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.city')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.City}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.country')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Country}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.phone')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Phone}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.fax')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Fax}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.email')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Email}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t('contract.basicdata.fields.website')}</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Web}</GridColumn></GridRow>
            </Grid>
          </GridColumn>


          <GridColumn width={5}>
            {contractData?.Links?.MainContracts && contractData?.Links?.MainContracts.length 
            ? <>
                <Header as='h4'>{t('contract.basicdata.section.mainContract')}</Header>
                <CardGroup>
                  {contractData?.Links.MainContracts?.map((link, index) => {
                    let statusColor;
                    let statusText;
                    switch (link.STATUS) {
                      case 1: 
                      case '1': statusColor = 'green'; statusText = t('contract.status.inProgress'); break;
                      case 3: 
                      case '3': statusColor = 'orange'; statusText = t('contract.status.released'); break;
                      default:  statusColor = 'grey'; statusText = t('contract.status.new');  break;
                    }
                    return (
                      <Card fluid color={statusColor} key={index} style={{ maxWidth: '399px' }}>
                        <CardContent style={{background: '#f5f5f5'}}>
                          <Grid columns={2}>
                            <GridRow>
                              <GridColumn width={14}>
                                <Grid columns={2}>
                                  <GridRow>
                                    <GridColumn width={16}>
                                      <Header as='h4'>{link.Basics.Hotelcode}</Header>
                                      {link.Basics.Hotelname}, {link.Basics.Season.value}
                                    </GridColumn>
                                  </GridRow>
                                  <GridRow className='media_ro_row'>
                                    <GridColumn width={4} className='media_ro_label' textAlign='right'>{t('contract.basicdata.fields.status')}:</GridColumn>
                                    <GridColumn width={12}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                  </GridRow>
                                </Grid>
                              </GridColumn>
                              <GridColumn width={2}><Button basic circular floated='right' icon='folder open outline' title={t('contract.basicdata.actions.openMainContract')} onClick={()=>handleOpenContractClick(link.id)}/></GridColumn>
                            </GridRow>
                          </Grid>
                        </CardContent>
                      </Card>
                    )
                  })}
                </CardGroup>
              </>
            : <>
                <Header as='h4'>{t('contract.basicdata.section.subContracts')}</Header>
                {(!contractData?.Links?.SubContracts || !contractData?.Links?.SubContracts.length) 
                  ? 
                    <>
                    <Header as='h4' textAlign='center'>
                      <Icon name='times circle outline' />
                      <HeaderContent>{t('contract.basicdata.noEntries')}</HeaderContent>
                    </Header>
                    <br />
                    </>
                  : 
                    <>
                    <CardGroup>
                      {contractData?.Links.SubContracts?.map((link, index) => {
                        let statusColor;
                        let statusText;
                        switch (link.STATUS) {
                          case 1: 
                          case '1': statusColor = 'green'; statusText = t('contract.status.inProgress'); break;
                          case 3: 
                          case '3': statusColor = 'orange'; statusText = t('contract.status.released'); break;
                          default:  statusColor = 'grey'; statusText = t('contract.status.new');  break;
                        }
                        return (
                          <Card fluid color={statusColor} key={index} style={{ maxWidth: '399px' }}>
                            <CardContent style={{background: '#f5f5f5'}}>
                              <Grid columns={2}>
                                <GridRow>
                                  <GridColumn width={14}>
                                    <Grid columns={2}>
                                      <GridRow>
                                        <GridColumn width={16}>
                                          <Header as='h4'>{link.Basics.Hotelcode}</Header>
                                          {link.Basics.Hotelname}, {link.Basics.Season.value}
                                        </GridColumn>
                                      </GridRow>
                                      <GridRow className='media_ro_row'>
                                        <GridColumn width={4} className='media_ro_label' textAlign='right'>{t('contract.basicdata.fields.status')}:</GridColumn>
                                        <GridColumn width={12}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                      </GridRow>
                                    </Grid>
                                  </GridColumn>
                                  <GridColumn width={2}>
                                    <Button basic circular floated='right' icon='folder open outline' title={t('contract.basicdata.actions.openSubContract')} onClick={()=>handleOpenContractClick(link.id)}/>
                                  </GridColumn>
                                </GridRow>
                              </Grid>
                            </CardContent>
                          </Card>
                        )
                      })}
                    </CardGroup>
                    </>
                }
              </>
            }

          </GridColumn>
        </GridRow>
      </Grid>
      <br />
      </>
    );
  }



  return (
    <>

    {/* Modal für Kopierfunktion */}
    <Modal
      closeIcon
      open={showSearchModal}
      onClose={() => closeSearchModalClick()}
      size='small'
    >
      <Header icon='copy outline' content='Verträge verknüpfen' />
      <Modal.Content>
        {isLoading 
          ? (
            <Segment>
              <Header as='h2' textAlign='center'>
                <Icon loading name='spinner' />
                <HeaderContent>
                  {t('contract.basicdata.loadingContracts')}
                </HeaderContent>
              </Header>
            </Segment>
          )
          : (
            <>
              {contracts.length ? (
              <Segment>
                <Header as='h2' textAlign='center'>
                  <HeaderContent>
                    {t('contract.basicdata.modal.availableContracts')}
                  </HeaderContent>
                </Header>
                <Container>
                  <CardGroup>
                    {contracts?.map((contract, index) => {
                      
                      let statusColor;
                      let statusText;
                      switch (contract?.Meta.Status) {
                        case '1':
                        case 1: statusColor = 'green'; statusText = t('contract.status.inProgress'); break;
                        case '3': 
                        case 3: statusColor = 'orange'; statusText = t('contract.status.released'); break;
                        default:  statusColor = 'grey'; statusText = t('contract.status.new');  break;
                      }
                      
                      const fdateStart = format(new Date(contract?.Period?.Start), 'dd.MM.yyyy')
                      const fdateEnd = format(new Date(contract?.Period?.End), 'dd.MM.yyyy')
                      const fdateAt = contract?.Meta?.HistoryAt 
                        ? format(new Date(contract?.Meta?.HistoryAt), 'dd.MM.yyyy, HH:mm') + ' Uhr'
                        : contract?.Meta?.ChangedAt ? format(new Date(contract?.Meta?.ChangedAt), 'dd.MM.yyyy, HH:mm') + ' Uhr' : '';
                      const changedBy = contract?.Meta?.HistoryBy ? contract?.Meta?.HistoryByName : contract?.Meta?.ChangedBy;
                      const changedText = contract?.Meta?.HistoryChange ? ', ' + contract?.Meta?.HistoryChange : '';

                      return (
                        <Card fluid color={statusColor} key={index}>
                          <CardContent style={{background: '#f5f5f5'}}>
                            <Grid columns={2}>
                              <GridRow>
                                <GridColumn width={14}>
                                  <Grid columns={2}>
                                    <GridRow>
                                      <GridColumn width={16}>
                                        <Header as='h4'>{contract.Hotelcode}</Header>
                                        {contract.Hotelname}, {contract.SeasonId}
                                      </GridColumn>
                                    </GridRow>
                                    <GridRow className='media_ro_row'>
                                      <GridColumn width={4} className='media_ro_label' textAlign='right'>Status:</GridColumn>
                                      <GridColumn width={12}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                    </GridRow>
                                    <GridRow className='media_ro_row'>
                                      <GridColumn width={4} className='media_ro_label' textAlign='right'>Laufzeit:</GridColumn>
                                      <GridColumn width={12}>{fdateStart} - {fdateEnd}</GridColumn>
                                    </GridRow>
                                    <GridRow className='media_ro_row'>
                                      <GridColumn width={4} className='media_ro_label' textAlign='right'>Änderung:</GridColumn>
                                      <GridColumn width={12} title={contract.Meta.Changed}>{fdateAt}, {changedBy}{changedText}</GridColumn>
                                    </GridRow>
                                  </Grid>
                                </GridColumn>
                                <GridColumn width={2}><Button basic circular floated='right' icon='linkify' title='Vertrag als Teilkontingent verknüpfen' onClick={()=>linkContractClick(contract)} /></GridColumn>
                              </GridRow>
                            </Grid>
                          </CardContent>
                        </Card>
                      )
                    })}
                  </CardGroup>
                </Container>
              </Segment>
            ) 
            : (
              <Segment>
                <Header as='h2' textAlign='center'>
                  <HeaderContent>
                    {t('contract.basicdata.noContractsFound')}
                  </HeaderContent>
                </Header>
                {/* 
                <Container textAlign='center'>
                  <br />
                  <Button basic circular icon labelPosition='left' style={{marginBottom: '20px'}} onClick={()=>openSearchModalClick('AGP10B')}><Icon name='add' />Neuen Vertrag als Teilkontingent hinzufügen</Button>
                  <Button basic circular icon labelPosition='left' style={{marginBottom: '20px'}} onClick={()=>openSearchModalClick('AGP10B')}><Icon name='copy outline' />Vertragskopie als Teilkontingent hinzufügen</Button>
                  <br />
                </Container>
                */}
              </Segment>
            )
          }
            </>
          )
        }
      </Modal.Content>
    </Modal>


    <Grid>
      <GridRow columns={3}>
        <GridColumn width={6}>
          <Header as='h4'>{t('contract.basicdata.section.mainHeader')}</Header>
          <Form>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label={t('contract.basicdata.fields.seasonRange')}        readOnly={readOnly} value={contractData.Basics.Season.value} options={derivedOptionsSeason}   placeholder={t('contract.basicdata.placeholders.seasonRange')}        onChange={(_, data) => dispatch(setContractData({target: 'Basics.Season', value: data.value}))} />
              <FormSelect fluid search selection label={t('contract.basicdata.fields.destinationAirport')} readOnly={readOnly} value={contractData.Basics.Destination}  options={derivedOptions3lc}      placeholder={t('contract.basicdata.placeholders.destinationAirport')} onChange={(_, data) => dispatch(setContractData({target: 'Basics.Destination', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label={t('contract.basicdata.fields.hotelChain')}         readOnly={readOnly} value={contractData.Basics.Hotelchain} options={derivedOptionsHotelchain} placeholder={t('contract.basicdata.placeholders.hotelChain')}         onChange={(_, data) => dispatch(setContractData({target: 'Basics.Hotelchain', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormInput fluid                   label={t('contract.basicdata.fields.hotelName')}          readOnly={readOnly} value={contractData.Basics.Hotelname}                                      placeholder={t('contract.basicdata.placeholders.hotelName')}         onChange={(_, data) => dispatch(setContractData({target: 'Basics.Hotelname', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label={t('contract.basicdata.fields.agencyCode')}         readOnly={readOnly} value={contractData.Basics.AgencyCode}  options={derivedOptionsAgency}     placeholder={t('contract.basicdata.placeholders.agencyCode')}        onChange={(_, data) => dispatch(setContractData({target: 'Basics.AgencyCode', value: data.value}))} />
              <FormInput fluid                   label={t('contract.basicdata.fields.toNumber')}           readOnly={readOnly} value={contractData.Basics.TONumber}                                       placeholder={t('contract.basicdata.placeholders.toNumber')}          onChange={(_, data) => dispatch(setContractData({target: 'Basics.TONumber', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label={t('contract.basicdata.fields.hotelType')}          readOnly={readOnly} value={contractData.Basics.HotelType}   options={derivedOptionsHoteltype}  placeholder={t('contract.basicdata.placeholders.hotelType')}         onChange={(_, data) => dispatch(setContractData({target: 'Basics.HotelType', value: data.value}))} />
              <FormInput fluid                   label={t('contract.basicdata.fields.touristicService')}   readOnly={readOnly} value={contractData.Basics.TLeistung}                                      placeholder={t('contract.basicdata.placeholders.touristicService')}  onChange={(_, data) => dispatch(setContractData({target: 'Basics.TLeistung', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label={t('contract.basicdata.fields.categoryOff')}        readOnly={readOnly} value={contractData.Basics.CategoryOff} options={derivedOptionsCategory}   placeholder={t('contract.basicdata.placeholders.categoryOff')}       onChange={(_, data) => dispatch(setContractData({target: 'Basics.CategoryOff', value: data.value}))} />
              <FormSelect fluid search selection label={t('contract.basicdata.fields.categoryInt')}        readOnly={readOnly} value={contractData.Basics.CategoryInt} options={derivedOptionsCategoryTO} placeholder={t('contract.basicdata.placeholders.categoryInt')}       onChange={(_, data) => dispatch(setContractData({target: 'Basics.CategoryInt', value: data.value}))} />
            </FormGroup>
          </Form>
        </GridColumn>

        <GridColumn width={5}>
          <Form>
            <Header as='h4'>{t('contract.basicdata.section.address')}</Header>
            <FormInput fluid label={t('contract.basicdata.fields.street')}     readOnly={readOnly} value={contractData.Basics.Contact.Street}    placeholder={t('contract.basicdata.placeholders.street')}  onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.Street', value: data.value}))} />
            <FormGroup>
              <FormInput fluid label={t('contract.basicdata.fields.postcode')} readOnly={readOnly} value={contractData.Basics.Contact.Postcode}  placeholder={t('contract.basicdata.placeholders.postcode')}  width={5}  onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.Postcode', value: data.value}))} />
              <FormInput fluid label={t('contract.basicdata.fields.city')}     readOnly={readOnly} value={contractData.Basics.Contact.City}      placeholder={t('contract.basicdata.placeholders.city')}      width={11} onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.City', value: data.value}))} />
            </FormGroup>
            <FormInput fluid label={t('contract.basicdata.fields.country')}    readOnly={readOnly} value={contractData.Basics.Contact.Country}   placeholder={t('contract.basicdata.placeholders.country')} onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.Country', value: data.value}))} />
            <FormInput fluid label={t('contract.basicdata.fields.phone')}      readOnly={readOnly} value={contractData.Basics.Contact.Phone}     placeholder={t('contract.basicdata.placeholders.phone')}   onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.Phone', value: data.value}))} />
            <FormInput fluid label={t('contract.basicdata.fields.fax')}        readOnly={readOnly} value={contractData.Basics.Contact.Fax}       placeholder={t('contract.basicdata.placeholders.fax')}     onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.Fax', value: data.value}))} />
            <FormInput fluid label={t('contract.basicdata.fields.email')}      readOnly={readOnly} value={contractData.Basics.Contact.Email}     placeholder={t('contract.basicdata.placeholders.email')}   onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.Email', value: data.value}))} />
            <FormInput fluid label={t('contract.basicdata.fields.website')}    readOnly={readOnly} value={contractData.Basics.Contact.Web}       placeholder={t('contract.basicdata.placeholders.website')} onChange={(_, data) => dispatch(setContractData({target: 'Basics.Contact.Web', value: data.value}))} />
          </Form>
        </GridColumn>
          
        <GridColumn width={5}>
          {(contractData?.Links?.MainContracts && contractData?.Links?.MainContracts.length) 
          ? <></>
          : <>
            <Header as='h4'>{t('contract.basicdata.section.subContracts')}</Header>
            {(!contractData?.Links?.SubContracts || !contractData?.Links?.SubContracts.length) 
              ? 
                <>
                <Header as='h4' textAlign='center'>
                  <Icon name='times circle outline' />
                  <HeaderContent>{t('contract.basicdata.noEntries')}</HeaderContent>
                </Header>
                <br />
                </>
              : 
                <>
                <CardGroup>
                  {contractData?.Links?.SubContracts?.map((link, index) => {
                    let statusColor;
                    let statusText;
                    switch (link.STATUS) {
                      case 1: 
                      case '1': statusColor = 'green'; statusText = t('contract.basicdata.status.inProgress'); break;
                      case 3: 
                      case '3': statusColor = 'orange'; statusText = t('contract.basicdata.status.released'); break;
                      default:  statusColor = 'grey'; statusText = t('contract.basicdata.status.new');  break;
                    }
                    return (
                      <Card fluid color={statusColor} key={index} style={{ maxWidth: '399px' }}>
                        <CardContent style={{background: '#f5f5f5'}}>
                          <Grid columns={2}>
                            <GridRow>
                              <GridColumn width={14}>
                                <Grid columns={2}>
                                  <GridRow>
                                    <GridColumn width={16}>
                                      <Header as='h4'>{link.Basics.Hotelcode}</Header>
                                      {link.Basics.Hotelname}, {link.Basics.Season.value}
                                    </GridColumn>
                                  </GridRow>
                                  <GridRow>
                                    <GridColumn width={5} textAlign='right'>Status:</GridColumn>
                                    <GridColumn width={11}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                  </GridRow>
                                </Grid>
                              </GridColumn>
                              <GridColumn width={2}><Button basic circular floated='right' icon='unlinkify' onClick={()=>unlinkContractClick(link)} /></GridColumn>
                            </GridRow>
                          </Grid>
                        </CardContent>
                      </Card>
                    )
                  })}
                </CardGroup>    
                </>
            }
            <br />
            <Button basic circular icon labelPosition='left' onClick={()=>openSearchModalClick('AGP10B')}><Icon name='add' />{t('contract.basicdata.addLink')}</Button>
            </>
          }
        </GridColumn>
      </GridRow>
    </Grid>
    </>
  );
}

export default Max2ContractBasicdata;